import { axios } from '@Root/API'

export const getStatic = () => {
	return axios.get('list/main-source-of-fee')
}
